import { render, staticRenderFns } from "./ImageGalleryItem.vue?vue&type=template&id=27ea2fcf&scoped=true"
import script from "./ImageGalleryItem.vue?vue&type=script&lang=js"
export * from "./ImageGalleryItem.vue?vue&type=script&lang=js"
import style0 from "./ImageGalleryItem.vue?vue&type=style&index=0&id=27ea2fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea2fcf",
  null
  
)

export default component.exports